export const STATE = {
  TERM: 'TERM',
  INTEREST_RATE: 'INTEREST_RATE',
  DOWNPAYMENT: 'DOWNPAYMENT',
  PRINCIPLE: 'PRINCIPLE',
  MODIFY_TERM: 'MODIFY_TERM',
  CHART_SELECTOR_PERCENTAGE_X: 'CHART_SELECTOR_PERCENTAGE_X',
  CHART_SELECTOR_SNAP_X: 'CHART_SELECTOR_SNAP_X',
  CHART_CLICK_INDEX: 'CHART_CLICK_INDEX',
  POINT_RADIUS: 'POINT_RADIUS',
  INTERVAL: 'INTERVAL',
  START_DATE: 'START_DATE',
  ANNUAL_PAYMENT_AMOUNT: 'ANNUAL_PAYMENT_AMOUNT',
  ONE_TIME_PAYMENT_AMOUNT: 'ONE_TIME_PAYMENT_AMOUNT',
  ANNUAL_PAYMENT_DATE: 'ANNUAL_PAYMENT_DATE',
  ONE_TIME_PAYMENT_DATE: 'ONE_TIME_PAYMENT_DATE',
  PAYMENT_DATA: 'PAYMENT_DATA',
  EXTRA_MONTHLY_PAYMENT_AMOUNT: 'EXTRA_MONTHLY_PAYMENT_AMOUNT',
  ERRORS: 'ERRORS',
  CURRENT_DISPLAY: 'CURRENT_DISPLAY',
  INSURANCE_COST: 'INSURANCE_COST',
  PROPERTY_TAX: 'PROPERTY_TAX',
  HOA_FEES: 'HOA_FEES'
};

export const MUTATIONS = {
  CHANGE: 'CHANGE',  //do not subscribe to base change !!!!
  CHANGE_MORTGAGE_START_DATE: 'CHANGE_MORTGAGE_START_DATE',
  CHANGE_EXTRA_MONTHLY_PAYMENT_AMOUNT: 'CHANGE_EXTRA_MONTHLY_PAYMENT_AMOUNT',
  CHANGE_ANNUAL_PAYMENT_DATE: 'CHANGE_ANNUAL_PAYMENT_DATE',
  CHANGE_ANNUAL_PAYMENT_AMOUNT: 'CHANGE_ANNUAL_PAYMENT_AMOUNT',
  CHANGE_ONE_TIME_PAYMENT_AMOUNT: 'CHANGE_ONE_TIME_PAYMENT_AMOUNT',
  CHANGE_ONE_TIME_PAYMENT_DATE: 'CHANGE_ONE_TIME_PAYMENT_DATE',
  CHANGE_DOWNPAYMENT: 'CHANGE_DOWNPAYMENT',
  CHANGE_INTEREST_RATE: 'CHANGE_INTEREST_RATE',
};

export const ACTIONS = {
  UPDATE_INSURANCE_COST: 'UPDATE_INSURANCE_COST',
  UPDATE_HOA: 'UPDATE_HOA',
  UPDATE_PROPERTY_TAX: 'UPDATE_PROPERTY_TAX',
  UPDATE_TERM: 'UPDATE_TERM',
  UPDATE_EXTRA: 'UPDATE_EXTRA',
  UPDATE_PRINCIPLE: 'UPDATE_PRINCIPLE',
  UPDATE_INTEREST_RATE: 'UPDATE_INTEREST_RATE',
  UPDATE_MORTGAGE_START_DATE: 'UPDATE_MORTGAGE_START_DATE',
  UPDATE_EXTRA_MONTHLY_PAYMENT_AMOUNT: 'UPDATE_EXTRA_MONTHLY_PAYMENT_AMOUNT',
  UPDATE_ANNUAL_PAYMENT_DATE: 'UPDATE_ANNUAL_PAYMENT_DATE',
  UPDATE_ANNUAL_PAYMENT_AMOUNT: 'UPDATE_ANNUAL_PAYMENT_AMOUNT',
  UPDATE_ONE_TIME_PAYMENT_AMOUNT: 'UPDATE_ONE_TIME_PAYMENT_AMOUNT',
  UPDATE_ONE_TIME_PAYMENT_DATE: 'UPDATE_ONE_TIME_PAYMENT_DATE',
  UPDATE_DOWNPAYMENT: 'UPDATE_DOWNPAYMENT',
};

export const GETTERS = {
  FORMATED_BREAKDOWN_PAYMENT: 'FORMATED_BREAKDOWN_PAYMENT',
  FORMATED_INSURANCE_COST: 'FORMATED_INSURANCE_COST',
  FORMATED_HOA: 'FORMATED_HOA',
  FORMATED_PROPERTY_TAX: 'FORMATED_PROPERTY_TAX',
  FORMATED_START_DATE: 'FORMATED_START_DATE',
  FORMATED_EXTRA_PAYMENT: 'FORMATED_EXTRA_PAYMENT',
  FORMATED_ANNUAL_PAYMENT_AMOUNT: 'FORMATED_ANNUAL_PAYMENT_AMOUNT',
  FORMATED_ANNUAL_PAYMENT_DATE: 'FORMATED_ANNUAL_PAYMENT_DATE',
  FORMATED_ONE_TIME_PAYMENT_AMOUNT: 'FORMATED_ONE_TIME_PAYMENT_AMOUNT',
  FORMATED_ONE_TIME_PAYMENT_DATE: 'FORMATED_ONE_TIME_PAYMENT_DATE',
  EXTRA_PAYMENT: 'EXTRA_PAYMENT',
  MODIFIED_PRINCIPLE: 'MODIFIED_PRINCIPLE',
  TERM_TEST: 'TERM_TEST',
  PAYOFF_DATE: 'PAYOFF_DATE',
  TERM_YEARS: 'TERM_YEARS',
  INTEREST_PERCENTAGE: 'INTEREST_PERCENTAGE',
  INTERVAL_LENGTH_MONTHS: 'INTERVAL_LENGTH_MONTHS',
  DOWNPAYMENT_PERCENTAGE: 'DOWNPAYMENT_PERCENTAGE',
  PAYMENT: 'PAYMENT',
  MODIFIED_TERM: 'MODIFIED_TERM',
  FORMATED_PAYMENT: 'FORMATED_PAYMENT',
  FORMATED_PRINCIPLE: 'FORMATED_PRINCIPLE',
  FORMATED_DOWNPAYMENT: 'FORMATED_DOWNPAYMENT',
  FORMATED_PAYMENT_AND_EXTRA: 'FORMATED_PAYMENT_AND_EXTRA'
};
